var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.00025,34 L10.00025,34 C9.73525,34 9.48025,34.106 9.29325,34.293 L0.29325,43.293 C-0.09775,43.684 -0.09775,44.316 0.29325,44.707 L9.29325,53.707 C9.48825,53.902 9.74425,54 10.00025,54 C10.25625,54 10.51225,53.902 10.70725,53.707 L19.70725,44.707 C19.89525,44.52 20.00025,44.265 20.00025,44 L20.00025,35 C20.00025,34.448 19.55225,34 19.00025,34 L19.00025,34 Z M10.00025,51.586 L2.41425,44 L4.00025,42.414 L11.58625,50 L10.00025,51.586 Z M18.00025,43.586 L13.00025,48.586 L5.41425,41 L10.41425,36 L18.00025,36 L18.00025,43.586 Z M15.00025,40.0001 C15.55225,40.0001 16.00025,39.5521 16.00025,39.0001 C16.00025,38.4481 15.55225,38.0001 15.00025,38.0001 C14.44825,38.0001 14.00025,38.4481 14.00025,39.0001 C14.00025,39.5521 14.44825,40.0001 15.00025,40.0001",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Library",
    transform: "translate(-42.000000, -124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "side-nav",
    transform: "translate(42.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon",
    fill: "#919EAB",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.0ecf9b2fa4b49c2ecb12027644a991f2.svg";
export { ForwardRef as ReactComponent };